 
 import React from 'react';
import { CaseItem, Transcription } from '../../Contexts/types';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { Table, Button, Modal } from 'antd';

interface CaseDetailsProps {
    cases: CaseItem[];
}

const TranscriptionTable: React.FC<CaseDetailsProps> = ({ cases }) => {
    const { id } = useParams<{ id: string }>();
    const caseDetails = cases.find((caseItem) => caseItem.basicData.id === id);
    const title = caseDetails?.basicData.title
    const navigate = useNavigate();

    const extractDateFromId = (id: string): string => {
        // Split by '-' and extract the last three segments, then join them
        const parts = id.split('-');
        const dateParts = parts.slice(-3).join('-'); // Extracts 'NOV', '18', '2024'
        return dateParts;
    };
    
    const showConfirmationModal = (record: Transcription) => {
        Modal.confirm({
          title: `Are you sure you want to upload a new transcription for this Session?`,
          content: `This action will update the presvious the transcription.`,
          okText: 'Yes',
          cancelText: 'No',
          onOk: () => {navigate(`/dashboard/upload-transcription/${record?.id}`, { state: { id: record?.id }});
          },
        });
    };

    const columns = [
        {
            title: 'Session Date',
            key: 'sessionDate',
            render: (_text: string, record: Transcription) => (
                extractDateFromId(record.id)
                ),
        },
        {
            title: 'Action',
            key: 'action',
            render: (_text: string, record: Transcription) => (
            <a href={record.fileURL} target="_blank" rel="noopener noreferrer">
                View Document
            </a>
            ),
        },
        {
            title: 'Upload New Transcription Document',
            key: 'modalAction',
            render: (record: Transcription) => {
                return (
                    <Button
                        type="primary"
                        className="bg-brown hover:bg-lightBrown"
                        onClick={() => showConfirmationModal(record)}
                    >
                        Upload
                    </Button>
                );
                }
        },
    ];

    return (
        <div>
            <div className='form-header'>Transcriptions for {title}</div>
            <Table 
                columns={columns} 
                dataSource={caseDetails?.transcriptions} 
                rowKey="id" 
                pagination={false} 
                className="custom-table ant-table"
            />
        </div>  
    )
}
export default TranscriptionTable
 